module.exports = __webpack_public_path__ + "static/media/la_kinfolk_dinner_41.44150063.jpg";